{
  "#STEMPELTERMINAL": {
    "APP": "Stempel",
    "TITLE": "Stempel-Terminal",
    "MESSAGES": {
      "ADD_SUCCESS": {
        "TITLE": "Erfolgreich",
        "MESSAGE": "Der Zeitstempel wurde erfasst."
      },
      "REMOVE_SUCCESS": {
        "TITLE": "Erfolgreich",
        "MESSAGE": "Der Zeitstempel wurde gelöscht."
      }
    },
    "MITARBEITER_DETAIL": {
      "KONTAKTDATEN": {
        "TITEL": "KONTAKTDATEN"
      },
      "DIENSTPLAN": {
        "TITEL": "DIENSTPLAN"
      },
      "STEMPEL": {
        "TITEL": "STEMPEL",
        "KOMMT_HEADER": "K",
        "GEHT_HEADER": "G",
        "KOMMT_GEHT": "K/G:",
        "KOMMT": "Kommt",
        "GEHT": "Geht",
        "TAG": "Tag:",
        "STEMPEL": "Stempel:",
        "CODE": "Code:",
        "UEBERNAHMEDATUM": "Übernahmedatum:",
        "ANWENDER": "Anwender:",
        "GERAET": "Gerät:",
        "ERFASSUNGSDATUM": "Erfassungsdatum:",
        "BEMERKUNG": "Bemerkung:",
        "TAETIGKEIT": "Tätigkeit:",
        "KST": "Kst:",
        "HERKUNFT": "Herkunft:",
        "GELOESCHT": "Gelöscht:"
      },
      "TERMINE": {
        "TITEL": "TERMINE"
      },
      "ISTZEIT": {
        "TITEL": "ISTZEIT"
      },
      "NICHT_ERFASST": "Nicht erfasst"
    }
  }
}
